module.exports = __webpack_public_path__ + "img/Mockup_A4_Brochure_2.08ee3a47.png";